<template>
    <VueFinalModal
        class="VolunteerProfilePreviewModal flex items-center justify-center"
        content-class="relative flex flex-col w-full max-w-6xl mx-0 sm:mx-4 p-0 bg-white dark:bg-surface-card rounded-none sm:rounded-lg h-screen sm:h-[90vh]"
        overlay-transition="vfm-fade"
        content-transition="vfm-fade"
        :click-to-close="true"
        :esc-to-close="true"
    >
        <div class="size-full flex flex-col">
            <div class="flex justify-between items-center p-6 border-b shrink-0">
                <h2 class="text-xl font-semibold">Náhľad dobrovoľníckeho profilu</h2>
                <button 
                    @click="handleClose"
                    class="modal-close absolute right-4 top-4 text-black dark:text-txt-headings hover:text-gray-600 hover:dark:text-txt-body z-10 text-4xl"
                >
                    ×
                </button>
            </div>
            <div class="bg-gray-50 dark:bg-subtle flex-1 overflow-y-auto p-6">
                <VolunteerView preview minified :profile="props.userProfile" />
            </div>
        </div>
    </VueFinalModal>
</template>

<script setup lang="ts">
import { VueFinalModal } from 'vue-final-modal'
import type { UserProfile } from '#shared/types/User'
import VolunteerView from '@/components/volunteer/VolunteerView.vue'

// Props
const props = defineProps<{
    userProfile: UserProfile
    onClose?: () => void
}>()

// Emits
const emit = defineEmits<{
    (e: 'close'): void
}>()

// Handle close - use callback if provided, otherwise emit
const handleClose = () => {
    if (props.onClose) {
        props.onClose()
    } else {
        emit('close')
    }
}
</script>